module.exports = __webpack_public_path__ + "static/media/dashed-line.95765c7b.svg";